import { ProductAPIList } from '@/api'
import Cookies from 'js-cookie'

const api = new ProductAPIList();
export default {
	getFullProductList({ state,commit }, param) {
    return new Promise((resolve, reject) => {
      api.getFullProductList(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        if(json.data.list && json.data.groupBuy){
          commit('setFullProductList', {list:json.data.list} );
          commit('setFullPackageList', {list:json.data.groupBuy} );
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },
selectProduct({ state }, param) {
    return new Promise((resolve, reject) => {
      api.selectProduct(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },
selectPackages({ state }, param) {
    return new Promise((resolve, reject) => {
      api.selectProduct(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },

}





// WEBPACK FOOTER //
// ./src/Product/store/actions.js